module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("安全基线检查修复")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("一、终端安全软件下载安装")]), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic01.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic08.png"),
      "width": "540px",
      "height": "660px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic07.png"),
      "width": "100%",
      "height": "500px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic02.png"),
      "width": "100%",
      "height": "500px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("二、通过MOA排查“安全基线检查”结果。")]), _c('br'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、打开MOA客户端页面，查看“安全基线检查”检查结果。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start",
      "margin-left": "20px"
    }
  }, [_vm._v("a、Windows系统打开MOA客户端方法：点击运行的MOA图标。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic03.png"),
      "width": "540px",
      "height": "160px"
    }
  }), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start",
      "margin-left": "20px"
    }
  }, [_vm._v("在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic04.png"),
      "width": "640px",
      "height": "440px"
    }
  }), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start",
      "margin-left": "20px"
    }
  }, [_vm._v("b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic05.png"),
      "width": "940px",
      "height": "600px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、排查“安全基线检测”。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/baselineRepair/baselineRepair_pic06.png"),
      "width": "660px",
      "height": "420px"
    }
  }), _c('br'), _vm._v("\n  a、赛门铁克杀毒软件相关基线   显示红色\n  "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n  ，表示赛门铁克杀毒软件未安装或未正常运行，请进入\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/saimenInstallForWin')
      }
    }
  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/saimenInstallForMac')
      }
    }
  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("进行排查。"), _c('br'), _vm._v("\n  b、数据防泄漏客户端相关基线  显示红色\n  "), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("\n  ，表示数据防泄漏客户端未安装、未注册、或未正常运行，请进入\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForWin')
      }
    }
  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/dataLeakInstallForMac')
      }
    }
  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("进行排查。"), _c('br'), _c('br'), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("a、如遇特殊情紧急情况，员工可申请临时白名单，请从此进入"), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/whiteApply')
      }
    }
  }, [_vm._v("临时白名单")]), _vm._v("。")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(250, 84, 28)"
    }
  }, [_vm._v("同学您好，您的PC终端安全不合规")])]), _vm._v("。请您根据拦截提示页面选择对应安全合规软件进行修复。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、"), _c('strong', [_vm._v("美团安全管理客户端（MOA）")]), _vm._v("下载安装")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 77, 79)"
    }
  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "100px"
    }
  }, [_c('p', [_vm._v("Mac："), _c('a', {
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/mac-for-1.3.1.0-release.pkg",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Mac下MOA下载")]), _vm._v(" 。"), _c('strong', [_vm._v("注意：MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本>=10.11）")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("MAC操作系统10.11以下版本存有多个安全漏洞，需要升级到10.11后才能修复，所以MOA、SEP、DLP最新版本对于10.10及以下操作系统不再提供兼容，必需要升级操作系统。升级MAC操作系统请联系6000帮助台协助。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("Windows: "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/MOA%20for%20Windows%201.3.0.0.exe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Win下MOA下载")]), _vm._v("。  "), _c('strong', [_vm._v("注意：Windows上MOA最新版本：【1.3.0.0 】（要求Windows 7及以上版本）")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("安装遇到问题请在左侧菜单栏"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("【常见问题FQA】")]), _vm._v("查看，若以上没有解决您的问题，请联系6000帮助台进行协助。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EEF977",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("「"), _c('span', {
    staticStyle: {}
  }, [_vm._v("当前计算机MOA未安装或不是最新版本，请点击「立即处理」")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EEF977",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("「"), _c('span', {
    staticStyle: {}
  }, [_vm._v("拦截提示：「终端安全不合规，请点击「立即处理」")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold"
    },
    attrs: {
      "id": "id-2、赛门铁克杀毒软件（SEP）下载安装"
    }
  }, [_vm._v("2、"), _c('strong', [_vm._v("赛门铁克杀毒软件（SEP）")]), _vm._v("下载安装")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 77, 79)"
    }
  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("Mac："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.2%20RU%202%20SEPRemote.pkg",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Mac下SEP下载")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("Windows 32位操作系统: "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x86_setup.exe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Win下32位SEP下载")]), _vm._v("。Windows 64位操作系统: "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x64_setup.exe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Win下64位SEP下载")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EEF977",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("您已被限制访问办公系统，请及时安装杀毒软件")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold"
    },
    attrs: {
      "id": "id-3、数据防泄漏客户端（DLP）下载安装"
    }
  }, [_vm._v("3、"), _c('strong', [_vm._v("数据防泄漏客户端（DLP）")]), _vm._v("下载安装")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 77, 79)"
    }
  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("Mac："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/mac%20new.zip",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Mac下DLP下载")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("Windows: "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/DLP.exe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Win下DLP下载")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EEF977",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("您已被限制访问办公系统，请及时安装杀毒软件")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、以上提示的红色"), _c('img', {
    attrs: {
      "src": require("../assets/terminalIllegal/terminalIllegal_pic05.png"),
      "width": "40px",
      "height": "30px"
    }
  }), _vm._v("修复完成后，请重新登录应用系统，如还有问题，请大象联系6000协助")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72c649d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baselineRepair.vue
// module id = 651
// module chunks = 1